var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    priceValue,
    priceDisplayValue,
    checkValue,
    className
  } = options;

__p+='\n';
 let checkFlag = (checkValue == priceValue || (checkValue == undefined && priceValue == '')) 
__p+='\n';
 var max_label; 
__p+='\n';
 if(checkFlag) {
     max_label = '';
     if(priceValue == '') {
      max_label = '';
     }
  } 

__p+='\n\n<option id="'+
((__t=( priceValue ))==null?'':__t)+
'" value="'+
((__t=( priceValue ))==null?'':__t)+
'" class="'+
((__t=( className ))==null?'':__t)+
'"\n  ';
 if(checkFlag){ 
__p+='\n    selected\n  ';
 } 
__p+='>\n    '+
((__t=( max_label ))==null?'':__t)+
' '+
((__t=( priceDisplayValue ))==null?'':__t)+
'\n</option>\n\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/ab_max_price_list.jst.ejs